(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnesio-welcome-popup"]) return;
  try {
    
  (() => {
    const init = () => {
      const dialog = document.querySelector('[data-mg-welcome]');
      if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      const storageKey = 'magnesio-welcome-email-seen-v1';
      const submittedKey = 'magnesio-welcome-email-subscribed-v1';
      const success = dialog.querySelector('[data-mg-signup-success]');
      const hasError = Boolean(dialog.querySelector('[data-mg-signup-error]'));
      if (success) {
        try { localStorage.setItem(submittedKey, '1'); sessionStorage.setItem(storageKey, '1'); } catch (_) {}
        const status = document.createElement('p');
        status.className = 'mg-welcome__toast';
        status.setAttribute('role', 'status');
        status.textContent = success.textContent;
        document.body.append(status);
        window.setTimeout(() => status.remove(), 8000);
        return;
      }
      if (!hasError) {
        try { if (localStorage.getItem(submittedKey) || sessionStorage.getItem(storageKey)) return; } catch (_) {}
      }
      let previousFocus;
      let timer;
      const dismiss = () => dialog.close();
      dialog.querySelectorAll('[data-mg-welcome-close]').forEach(button => button.addEventListener('click', dismiss));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mg-welcome-open');
        if (previousFocus && previousFocus.isConnected && previousFocus !== document.body) previousFocus.focus({ preventScroll: true });
      });
      const show = () => {
        if (!dialog.isConnected) return;
        if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) {
          timer = window.setTimeout(show, 1500);
          return;
        }
        previousFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('mg-welcome-open');
        try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
      };
      timer = window.setTimeout(show, hasError ? 0 : (Number(dialog.dataset.delay) || 5000));
      window.addEventListener('pagehide', () => { clearTimeout(timer); if (dialog.open) dialog.close(); }, { once: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
